<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.priceTypeTemplate')"
    resource="price_type_templates"
    :actionColumnProps="{ width: 140 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/price_type_templates.js';
import { formColumnsExtend as PTFormColumnsExtend } from '../admin_entities/price_type_detail.js';

@Component
export default class PriceTypeTemplates extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      {
        key: 'price_types',
        renderCell: (h, { props: { value } }) => {
          console.log(value);

          return <ul style="text-align: left">{value.map(v => <li>{v.name}: {v.amount} 元</li>)}</ul>;
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'price_types',
        renderCell: {
          component: 'nestForm',
          props: {
            columns: PTFormColumnsExtend(['name', 'amount'], { data: {}, type: type })
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'price_type_templates.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'price_type_templates.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/price_type_templates',
    name: 'price_type_templates.index',
    component: PriceTypeTemplates,
    props: {
      type: 'index',
    }
  },
  {
    path: '/price_type_templates/new',
    name: 'price_type_templates.new',
    component: PriceTypeTemplates,
    props: {
      type: 'new',
    }
  },
  {
    path: '/price_type_templates/:id',
    name: 'price_type_templates.show',
    component: PriceTypeTemplates,
    props: {
      type: 'show',
    }
  },
  {
    path: '/price_type_templates/:id/edit',
    name: 'price_type_templates.edit',
    component: PriceTypeTemplates,
    props: {
      type: 'edit'
    }
  }
]
</script>
